export const ACTION_BUTTON_TYPES = {
  EDIT: {
    name: "EDIT",
    type: "a",
    title: "actionButtonGenerator.guncelle",
  },
  ARCHIVE: {
    name: "ARCHIVE",
    type: "a",
    title: "actionButtonGenerator.arsivVeYonetim",
  },
  UPLOAD_BUTTON: {
    name: "UPLOAD_BUTTON",
    type: "a",
    title: "actionButtonGenerator.dosyaYukle",
  },
  UPLOAD_USER_FILES: {
    name: "UPLOAD_BUTTON",
    type: "a",
    title: "actionButtonGenerator.kullaniciDosyaYukle",
  },
  ACTIVE: {
    name: "ACTIVE",
    type: "a",
    title: "actionButtonGenerator.aktifEt",
    stId: 90,
    isActive: (row) => row.stId === 91
  },
  PASSIVE: {
    name: "PASSIVE",
    type: "a",
    title: "actionButtonGenerator.pasifEt",
    stId: 91,
    isActive: (row) => row.stId === 90
  },
  GOTOPAGE: {
    name: "GOTOPAGE",
    type: "a",
    title: "actionButtonGenerator.sayfayaGit",
  },
  GOTOPAGETWO: {
    name: "GOTOPAGETWO",
    type: "a",
    title: "actionButtonGenerator.sayfayaGit",
  },
  DELETE: {
    name: "DELETE",
    type: "a",
    title: "actionButtonGenerator.sil"
  },
  DELETE_MULTIPLE: {
    name: "DELETE",
    type: "a",
    title: "actionButtonGenerator.sil",
    multi: true
  },
  UPLOAD: {
    name: "UPLOAD",
    type: "upload",
    title: "actionButtonGenerator.dosyaYukle",
  },
  DOWNLOAD: {
    name: "DOWNLOAD",
    type: "a",
    title: "actionButtonGenerator.dosyaIndir",
  },
  DOWNLOAD_MULTIPLE: {
    name: "DOWNLOAD",
    type: "a",
    title: "actionButtonGenerator.dosyalariIndir",
    multi: true
  },
  EXCEL_EXPORT: {
    name: "EXCEL_EXPORT",
    type: "a",
    title: "actionButtonGenerator.excel",
    unSelected: true,
    className: "float-right"
  },
  PREVIEW: {
    name: "PREVIEW",
    type: "a",
    title: "actionButtonGenerator.goruntule",
  },
  AUTH: {
    name: "AUTH",
    type: "auth",
    title: "actionButtonGenerator.yetkiEkle",
  },
  UPDATE_ALL_ITEM: {
    name: "UPDATE_ALL_ITEM",
    type: "a",
    title: "actionButtonGenerator.tumKayitlariGuncelle",
    unSelected: true,
    className: "float-right"
  },
};

const DefaultActionButtonGenerator = (actionButtonsObject, eventsObject) => {
  const { actions: buttonTypesArray } = actionButtonsObject;

  if (!buttonTypesArray || buttonTypesArray.length === 0) {
    return;
  }
  const resultObject = {};

  buttonTypesArray.forEach((buttonType) => {
    resultObject[buttonType.name] = {
      type: buttonType.type,
      multi: buttonType.multi || false,
      isActive: buttonType.isActive || true,
      name: buttonType.name,
      title: buttonType.title,
      className: buttonType.className || "",
      icon: buttonType.icon,
      onClick: eventsObject[buttonType.name]
        ? () => eventsObject[buttonType.name](buttonType)
        : eventsObject[buttonType.old_name]
        ? () => eventsObject[buttonType.old_name](buttonType)
        : null,
      onConfirm: eventsObject[buttonType.name]
        ? (params = null) => eventsObject[buttonType.name](buttonType, params)
        : null,
      body: buttonType.body,
      endpoint: buttonType.endpoint,
      reqType: buttonType.reqType,
      pushWithId: buttonType.pushWithId,
      params: buttonType.params,
      pushWithRow: buttonType.pushWithRow,
      requestTo: buttonType.requestTo,
      entity: buttonType.entity,
      dropdownLabel: buttonType.dropdownLabel,
      isPlan: buttonType.isPlan,
      isReason: buttonType.isReason,
      label: buttonType.label,
      stId: buttonType.stId,
      unSelected: buttonType.unSelected,
    };
  });

  return resultObject;
};

export default DefaultActionButtonGenerator;

// export const WithPermissionsActionButtonGenerator = (
//   actionButtonsObject,
//   eventsObject,
//   user
// ) => {
//   const { actions: buttonTypesArray, permBase } = actionButtonsObject;

//   if (
//     !buttonTypesArray ||
//     buttonTypesArray.length === 0 ||
//     !(user && user.perms)
//   ) {
//     return;
//   }

//   const resultObject = {};

//   buttonTypesArray.forEach((button) => {
//     if (
//       !button.permAction ||
//       hasPermission(permBase, button.permAction, user.perms)
//     ) {
//       resultObject[button.name] = {
//         type: button.type,
//         multi: button.multi || false,
//         isActive: button.isActive || true,
//         name: button.name,
//         title: button.title,
//         className: "",
//         icon: button.icon,
//         onClick: eventsObject[button.name]
//           ? () => eventsObject[button.name](button)
//           : null,
//         onConfirm: eventsObject[button.name]
//           ? (params = null) => eventsObject[button.name](button, params)
//           : null,
//         onClose: button.onClose || null,
//         body: button.body,
//         endpoint: button.endpoint,
//         reqType: button.reqType,
//         pushWithId: button.pushWithId,
//         pushTo: button.pushTo,
//         pushWithRow: button.pushWithRow,
//         requestTo: button.requestTo,
//         entity: button.entity,
//         dropdownLabel: button.dropdownLabel,
//         isPlan: button.isPlan,
//         isReason: button.isReason,
//         label: button.label,
//       };
//     }
//   });

//   return resultObject;
// };

//#region WRAPPER FUNCTIONS
export const pushToParams = (buttonObj, params) => {
  return {
    ...buttonObj,
    params: params,
  };
};

export const pushWithId = (buttonObj, url) => {
  return {
    ...buttonObj,
    pushWithId: url,
  };
};

export const requestTo = (buttonObj, url) => {
  return {
    ...buttonObj,
    requestTo: url,
  };
};

export const pushWithRow = (buttonObj, url) => {
  return {
    ...buttonObj,
    pushWithRow: url,
  };
};

export const addActiveFn = (buttonObj, isActiveFn) => {
  return {
    ...buttonObj,
    isActive: isActiveFn,
  };
};

export const withNewTitle = (buttonObj, newTitle) => {
  return {
    ...buttonObj,
    title: newTitle,
  };
};

export const withNewTitleAndName = (buttonObj, newTitle, name) => {
  return {
    ...buttonObj,
    title: newTitle,
    old_name: buttonObj.name,
    name: name,
  };
};

export const withEndPoint = (buttonObj, endPoint) => {
  return {
    ...buttonObj,
    endpoint: endPoint,
  };
};

export const withEndPointAndType = (buttonObj, endPoint, type) => {
  return {
    ...buttonObj,
    endpoint: endPoint,
    reqType: type,
  };
};
//#endregion
